const STORAGE_KEY = "virdio_active_session";
const HEARTBEAT_INTERVAL = 3000;

class CrashRecoveryService {
  constructor() {
    this.heartbeatInterval = null;
    this.stressInterval = null;
    this.canvasInterval = null;
    this.memoryHog = [];
    console.log("CrashService: Service Initialized");
  }

  wasLastSessionCrash() {
    const navEntries = performance.getEntriesByType("navigation");
    if (navEntries.length === 0) {
        console.log("CrashService: No navigation entries found. Skipping check.");
        return false;
    }

    const navType = navEntries[0].type; 
    const savedData = sessionStorage.getItem(STORAGE_KEY); 

    console.log(`CrashService: --- Detection Trace Start ---`);
    console.log(`CrashService: 1. Navigation Type: ${navType}`);

    // Check for Back/Forward navigation
    if (navType === 'back_forward') {
        console.log("CrashService: 2. Result: User used Back/Forward button. Clearing session and exiting.");
        sessionStorage.removeItem(STORAGE_KEY);
        return false;
    }

    if (!savedData) {
        console.log("CrashService: 2. Result: No saved session data found in storage. Fresh start.");
        return false;
    }

    try {
        const { timestamp, status } = JSON.parse(savedData);
        const age = Date.now() - timestamp;
        console.log(`CrashService: 2. Saved Session Found: Status [${status}], Age [${(age/1000).toFixed(1)}s]`);

        // Check for Intentional Exit (Set by index.html or logout)
        if (status === 'intentional_exit' || status === 'completed') {
            console.log(`CrashService: 3. Result: Found '${status}' flag. User exited normally. Clearing storage.`);
            sessionStorage.removeItem(STORAGE_KEY);
            return false;
        }

        // The Critical Crash Check
        if (status === 'active') {
            if (age < 15000) {
                console.warn("CrashService: 3. Result: CRASH CONFIRMED. Session was active and interrupted recently.");
                return true;
            } else {
                console.log(`CrashService: 3. Result: Session was 'active' but too old (${(age/1000).toFixed(1)}s). Ignoring as stale.`);
            }
        } else {
            console.log(`CrashService: 3. Result: Unknown status [${status}]. No action taken.`);
        }

        // Cleanup for false positives
        console.log("CrashService: 4. Finalizing: Clearing storage to prevent repeat triggers.");
        sessionStorage.removeItem(STORAGE_KEY);
        
    } catch (e) {
        console.error("CrashService: Error parsing session data:", e);
        sessionStorage.removeItem(STORAGE_KEY);
    }

    console.log(`CrashService: --- Detection Trace End ---`);
    return false;
  }

  startHeartbeat() {
    // this.stopHeartbeat();
    sessionStorage.removeItem(STORAGE_KEY);
    console.log("CrashService: Starting Heartbeat...");

    const update = () => {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        timestamp: Date.now(),
        status: 'active'
      }));
    };
    
    update();
    this.heartbeatInterval = setInterval(update, HEARTBEAT_INTERVAL);
  }

  stopHeartbeat(graceful = false) {
    if (this.heartbeatInterval) {
      clearInterval(this.heartbeatInterval);
      this.heartbeatInterval = null;
      console.log("CrashService: Heartbeat Paused/Stopped.");
    }
    if (graceful) {
      console.log("CrashService: Marking session as 'completed' (Graceful Exit).");
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        timestamp: Date.now(),
        status: 'completed'
      }));
    }
  }
    
  startStressTest() {
    // --- SETTINGS FOR 10-15 SECOND CRASH ---
    const CHUNKS_PER_CYCLE = 10;   // Increase this for a faster crash
    const CYCLE_SPEED_MS = 250;    // Decrease this for a faster crash (lower is faster)
    // ---------------------------------------

    this.stressInterval = setInterval(() => {
      try {
        for (let i = 0; i < CHUNKS_PER_CYCLE; i++) {
          // We use Float64Array to ensure the browser reserves actual memory
          this.memoryHog.push(new Float64Array(1024 * 1024)); 
        }
        
        // Monitor progress in console
        const totalAllocatedMB = (this.memoryHog.length * 8).toFixed(0);
        console.log(`STRESS_TEST: Speed: ${CYCLE_SPEED_MS}ms | Total: ~${totalAllocatedMB}MB`);
        
      } catch (e) {
        console.error("STRESS_TEST: OOM (Out of Memory) reached!");
      }
    }, CYCLE_SPEED_MS);

    // Keep the GPU busy so it can't help with memory management
    this.canvasInterval = setInterval(() => {
      const canvas = document.createElement('canvas');
      canvas.width = 2000; canvas.height = 2000;
      const ctx = canvas.getContext('2d');
      ctx.createImageData(2000, 2000); 
    }, 100);
  }

  stopStressTest() {
    if (this.stressInterval || this.canvasInterval) {
        clearInterval(this.stressInterval);
        clearInterval(this.canvasInterval);
        
        // Explicitly nullify to help Garbage Collection
        this.memoryHog = []; 
        
        // Optional: clear the canvas to release GPU resources
        const canvas = document.querySelector('canvas');
        if (canvas) {
            canvas.width = 1; 
            canvas.height = 1;
        }

        console.log("STRESS_TEST: Deactivated. Memory references cleared.");
    }
}

  handleIntentionalExit() {
      const savedData = sessionStorage.getItem(STORAGE_KEY);
      if (savedData) {
        const data = JSON.parse(savedData);
        data.status = 'intentional_exit'; 
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      }
    };

  clearSession() {
      console.log("CrashService: Intentional exit, clearing session.");
      sessionStorage.removeItem(STORAGE_KEY);
      sessionStorage.removeItem("didCrash");
  }

  didCrashLastTime() {
    console.log("CrashService: Checking for crash flag...");
    var didCrash = sessionStorage.getItem("didCrash");
    console.log("CrashService: Crash flag value:", didCrash);
    if (didCrash && didCrash === "true") {
      sessionStorage.removeItem("didCrash");
      // Crash Detected message sent
      console.log("CrashService: crash flag detected, informing flutter...");
      if (window.appCrashDetected){
        window.appCrashDetected();
      }
      return true;
    }
    return false;
  }
}

const serviceInstance = new CrashRecoveryService();
window.RecoveryService = serviceInstance;

export default serviceInstance;